import BusinessTravellerSelectHotelsRoomsContent from './BusinessTravellerSelectHotelsRoomsContent'
import * as React from 'react'
import Modal from 'LuxKit/Modal/Modal'
import { useCallback } from 'react'
import useModalElementContext from 'hooks/Modal/useModalElementContext'

export default function BusinessTravellerSelectHotelsRoomsModal({ onApply }: { onApply: () => void }) {
  const modalElementContext = useModalElementContext()

  const dismiss = useCallback(() => {
    modalElementContext.resolve()
    onApply()
  }, [modalElementContext, onApply])

  return <Modal
    mode="drawer"
    title="How many rooms?"
    primaryActionText="Continue"
    onPrimaryActionClick={dismiss}
  >
    <BusinessTravellerSelectHotelsRoomsContent size="large" />
  </Modal>
}
